import { render, staticRenderFns } from "./CbtExams.vue?vue&type=template&id=9282fa70&scoped=true"
import script from "./CbtExams.vue?vue&type=script&lang=js"
export * from "./CbtExams.vue?vue&type=script&lang=js"
import style0 from "./CbtExams.vue?vue&type=style&index=0&id=9282fa70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9282fa70",
  null
  
)

export default component.exports